function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoBeta(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 497.34 215.19",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer_1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M144.4,65.89h15.2v5.3c4.1-4.2,9.6-6.6,16-6.6,14.7,0,25.6,12,25.6,27.8s-10.9,27.8-25.6,27.8-12-2.4-16-6.6v25.1h-15.2v-72.9.1ZM185.7,92.49c0-7.5-5.5-13.1-13-13.1s-13,5.6-13,13.1,5.5,13.1,13,13.1,13-5.6,13-13.1Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208,43.99h15.2v75h-15.2V43.99Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.1,100.29v-34.4h15.2v29.8c0,5.9,3.8,9.9,9.5,9.9s10.3-4.1,10.3-10.1v-29.6h15.2v53.1h-15.2v-5.2c-4,4.3-9.2,6.5-15.4,6.5-11.8,0-19.6-7.9-19.6-20h0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291,100.29v-34.4h15.2v29.8c0,5.9,3.8,9.9,9.5,9.9s10.3-4.1,10.3-10.1v-29.6h15.2v53.1h-15.2v-5.2c-4,4.3-9.2,6.5-15.4,6.5-11.8,0-19.6-7.9-19.6-20h0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.5,114.59c3.2,1.3,6.7,2,10.5,2s7.3-.6,10.5-2c3.2-1.3,6-3.1,8.3-5.4s4.2-5,5.5-8.2,2-6.6,2-10.4-.7-7.2-2-10.3c-.2-.6-.5-1.1-.8-1.7h2.9v-14h-26.5c-3.8,0-7.3.6-10.5,2-3.2,1.3-6,3.1-8.3,5.4s-4.1,5.1-5.5,8.3-2,6.7-2,10.4.7,7.2,2,10.4c1.3,3.2,3.2,5.9,5.5,8.2s5.1,4.1,8.3,5.4h0l.1-.1ZM363.3,86.09c.6-1.5,1.4-2.8,2.4-3.9s2.3-2,3.7-2.6,3-1,4.8-1h0c1.7,0,3.3.3,4.7,1s2.6,1.5,3.7,2.6,1.8,2.4,2.3,3.9.8,3,.8,4.7-.3,3.1-.9,4.6-1.3,2.7-2.3,3.8-2.2,1.9-3.6,2.6c-1.4.6-3,1-4.7,1s-3.3-.3-4.8-1-2.7-1.5-3.8-2.6c-1-1.1-1.8-2.3-2.4-3.8s-.8-3-.8-4.6.3-3.2.8-4.7h.1Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M402.3,136.89h0c-1.7-7.6-8.5-13.3-16.7-13.3h-16c-2.3,0-4.3-1.9-4.3-4.3v-2.8h-14.3v4.2c0,9.5,7.7,17.1,17.1,17.1h16c.4,0,.7,0,1.1.1,1.8.5,2.3,2.8.9,4h0c-4.6,4.1-19.5,2.3-30.4,1-5-.6-9.8-1.2-14.2-1.4-1.8,0-3.8-.2-6-.3-22.9-1.3-70.4-4-132.2,14.8-45.3,13.8-73.1,13.6-93.6-.5-9.2-6.3-14-14.3-16.5-20.6h8.9v-3.9c.2-6,1.2-10.9,2.7-15,1.6-4.3,3.8-7.8,6.2-11.2,4.6-6.5,9.9-12.2,13-21.7v-16.8h-13v-22h-8.9v22h-15.3v9.6c0,.4,0,.5.5.6,2.3.3,4.5.9,6.5,2.4,1.9,1.5,3,3.4,3.5,5.8-2.4.3-4.7.5-7.1.8-.5-1.8-1.5-3.1-3.3-3.8v8.7c0,.4.1.5.4.5,2.1.5,4.2,1.1,6.2,2.1s3.5,2.3,4.3,4.4c.7,1.7.8,3.4.6,5.2-.5,3.6-2.7,6-5.8,7.7-1.7.9-3.5,1.3-5.3,1.6-.3,0-.4.2-.4.4v4h-4.1v-4.2c-.7-.1-1.4-.2-2-.4-2.8-.6-5.2-1.8-7.1-4-1.4-1.7-2.2-3.7-2.6-5.9,2.5-.2,4.9-.4,7.3-.7.6,2.4,2.1,4.1,4.4,5.2v-9.5c0-.3-.1-.4-.4-.5-2.1-.5-4.2-1.3-6-2.5-2.8-1.9-4.2-4.6-4.2-8s1.7-5.9,4.6-7.7c1.7-1,3.6-1.5,5.5-1.7h.4v-10.1h-15.4v-22h-8.9v22h-13v16.8c3.1,9.5,8.4,15.2,13,21.7,2.4,3.3,4.6,6.9,6.2,11.2,1.5,4.1,2.6,8.9,2.7,15v3.9h9c2.6,9.2,9,23.1,24,33.5,13.2,9.2,23.2,13.8,43.9,13.8s39.7-3.7,63.8-11c59.1-17.9,103-15.4,126.6-14.1,2.3.1,4.3.2,6.1.3,3.9.2,8.3.7,13.1,1.3,16.2,1.9,32.9,3.9,42.9-4.9,3.1-2.8,4.7-6.2,5.5-10.4.1-.6.2-1.3.3-1.9.2-1.6.1-3.2-.2-4.8h0v.2Z",
    style: {
      fill: "#98fb98"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.1,85.99c0,1.9,1.6,3.4,3.6,4v-8.1c-2,.4-3.6,2.3-3.6,4.1h0Z",
    style: {
      fill: "#98fb98"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.9,104.39c.8-1.3.9-2.7.2-4.1-.9-1.6-2.5-2.1-4.2-2.6v9.2c1.7-.3,3.1-1,4.1-2.5h-.1Z",
    style: {
      fill: "#98fb98"
    }
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 265.9,
    y: 147.87,
    width: 136.35,
    height: 42.18,
    rx: 6,
    ry: 6,
    style: {
      stroke: "#fff",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M309.96,170.88c.92,1.18,1.38,2.52,1.38,4.03,0,2.18-.76,3.91-2.29,5.19-1.52,1.28-3.65,1.92-6.38,1.92h-12.16v-26.11h11.75c2.65,0,4.73.61,6.23,1.82,1.5,1.21,2.25,2.86,2.25,4.95,0,1.54-.4,2.81-1.21,3.83-.81,1.02-1.88,1.72-3.22,2.12,1.51.32,2.73,1.07,3.64,2.25ZM296.87,166.47h4.17c1.04,0,1.84-.23,2.4-.69.56-.46.84-1.13.84-2.03s-.28-1.57-.84-2.05c-.56-.47-1.36-.71-2.4-.71h-4.17v5.47ZM304.03,176.16c.58-.48.87-1.18.87-2.1s-.3-1.64-.91-2.16c-.61-.52-1.44-.78-2.51-.78h-4.61v5.76h4.69c1.07,0,1.89-.24,2.47-.73Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.37,161v5.28h8.52v4.91h-8.52v5.73h9.63v5.09h-15.99v-26.11h15.99v5.09h-9.63Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.91,155.91v5.09h-6.92v21.01h-6.36v-21.01h-6.92v-5.09h20.19Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.36,177.4h-9.74l-1.56,4.61h-6.66l9.45-26.11h7.36l9.45,26.11h-6.73l-1.56-4.61ZM371.73,172.49l-3.24-9.56-3.2,9.56h6.43Z",
    style: {
      fill: "#fff"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoBeta);
export default __webpack_public_path__ + "static/media/logo-beta.09cd6781ddbb369a18885530b76f97b9.svg";
export { ForwardRef as ReactComponent };